import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';

import App from "./App";
import StoreProvider from "./utils/store";
import './utils/network';

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <StoreProvider>
        <App />
      </StoreProvider>
    </PersistGate>
  </Provider>
);
